import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { userRolesData, roles } from '../mockData/user-roles-data';
import { usersListData } from '../mockData/users-list-data';

const UserRolesApi = [
  rest.get(`${API_ROOT}users`, (req, res, ctx) => {
    const skip = req.url.searchParams.get('$skip');
    const limit = req.url.searchParams.get('limit');
    const search = req.url.searchParams.get('search');
    if ((skip === '0' && limit === '10') || search) {
      return res(ctx.json(usersListData));
    }
    return res(ctx.json(userRolesData));
  }),
  rest.get(`${API_ROOT}roles`, (req, res, ctx) => res(ctx.json(roles))),
  rest.post(`${API_ROOT}user-roles`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.delete(`${API_ROOT}user-roles`, (req, res, ctx) => res(ctx.json({ id: 319 }))),
];
export default UserRolesApi;
